<template>
<div v-show="false">{{loginStatus}}</div>

<van-tabs v-show="loginResult" v-model:active="active" @click="clickTab" type="card" style="margin-top:5px">
  <van-tab title="个人业绩" v-show="state.showUserTab">
    <van-cell is-link @click="state.showPicker_year_month = true" key="年月">{{state.value_year_month}}</van-cell>
    <van-popup v-model:show="state.showPicker_year_month" round position="bottom">
    <van-datetime-picker
      v-model="currentDate"
      type="year-month"
      title="选择年月"
      @cancel="state.showPicker_year_month = false"
      @confirm="onConfirm_yearMonth"
      :min-date="state.minDate"
    />
    </van-popup>

    <van-row justify="space-around" style="margin-top:20px">
      <van-col style="text-align:center">
        <div>月度</div>
        <van-circle
          v-model:current-rate="currentRate_month_user"
          :rate="(state.persondata.month_reach?state.persondata.month_reach:0)"
          :speed="100"
          size="80px"
          :text="(state.persondata.month_reach?state.persondata.month_reach:0)+'%'"
          :stroke-width="80"
          layer-color="#ebedf0"
          color="#FFA54F"
          style="margin-top: 5px;"
        />
        <div class="div">达成：{{state.persondata.month_reach_total?state.persondata.month_reach_total:0}}万元</div>
        <div class="div">目标：{{state.persondata.month_goal?state.persondata.month_goal:0}}万元</div>
      </van-col>
      
      <van-col style="text-align:center">
      <div>季度</div>
      <van-circle
          v-model:current-rate="currentRate_season_user"
          :rate="(state.persondata.season_reach?state.persondata.season_reach:0)"
          :speed="100"
          size="80px"
          :text="(state.persondata.season_reach?state.persondata.season_reach:0)+'%'"
          :stroke-width="80"
          color="#FF4500"
          layer-color="#ebedf0"
          style="margin-top: 5px;"
        />
        <div class="div">达成：{{state.persondata.season_reach_total?state.persondata.season_reach_total:0}}万元</div>
        <div class="div">目标：{{state.persondata.season_goal?state.persondata.season_goal:0}}万元</div>
      </van-col>

      <van-col style="text-align:center">
      <div>年度</div>
      <van-circle
          v-model:current-rate="currentRate_year_user"
          :rate="(state.persondata.year_reach?state.persondata.year_reach:0)"
          :speed="100"
          size="80px"
          :text="(state.persondata.year_reach?state.persondata.year_reach:0)+'%'"
          :stroke-width="80"
          color="#CD0000"
          layer-color="#ebedf0"
          style="margin-top: 5px;"
        />
        <div class="div">达成：{{state.persondata.year_reach_total?state.persondata.year_reach_total:0}}万元</div>
        <div class="div">目标：{{state.persondata.year_goal?state.persondata.year_goal:0}}万元</div>
      </van-col>
    </van-row>

    <div style="border: 1px solid rgb(235, 225, 225);margin-top:20px"></div>

    <van-cell-group title="业绩来源">
      <van-cell title="项目/合同" value="获得业绩" />
    </van-cell-group>

    <van-collapse v-model="activeName" accordion>
      <div v-for="(person, index) in state.personlist" :key="index">
        <van-collapse-item :title="person.month_str">
            <div v-for="(detail, i) in person.itemdetail" :key="i">
              <van-cell :title="detail.itemname" :value="detail.reach_money" />
            </div>
        </van-collapse-item>
      </div>
    </van-collapse>
 
  </van-tab>
  <van-tab title="个人排行" v-show="state.showUserRankTab">
    <div style="margin-left:16px;margin-top:10px" v-show="state.user.rank.info.showRankInfo">
      <div>亲爱的{{state.user.rank.info.orgname}}</div>
       <div>您在当前团队排名：<span style="color:red">第{{state.user.rank.info.teamrank}}</span></div>
      <div v-show="state.user.rank.info.deptnameShow">您在{{state.user.rank.info.deptname}}整体排名：<span style="color:red">第{{state.user.rank.info.deptrank}}</span>
      </div>
    </div>
    <div>
      <van-cell is-link @click="state.user.rank.showPicker = true" key="部门">{{state.user.rank.value}}</van-cell>
      <van-number-keyboard safe-area-inset-bottom />
      <van-popup v-model:show="state.user.rank.showPicker" round position="bottom">
      <van-picker
        :columns="state.user.rank.columns"
        @cancel="state.user.rank.showPicker = false"
        @confirm="onConfirmRank"
        :default-index="state.user.rank.selectedIndex"
      />
      </van-popup>
    </div>

    <div id="echartUser" style="width: 100%;height: 400px; padding-top: .6rem; padding-left: 10px">
    </div>
  </van-tab>
  <van-tab v-for="item in Object.keys(tabs)" :key="item" :title="item">
    <component :is="tabs[item]" />
  </van-tab>
</van-tabs>

</template>

<script>
import {getPersonData, getUserRankData} from "@/http/api"; 
import { createApp } from 'vue';
import { Grid, GridItem } from 'vant';
import { Icon } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Tab, Tabs } from 'vant';
import { ref } from 'vue';
import { Col, Row } from 'vant';
import { reactive } from 'vue';
import { Toast } from 'vant';
import {comdify} from "@/utils/common.js"
import {getQueryVariable} from "@/utils/common.js"
import { Picker } from 'vant';
import { Field } from 'vant';
import { Popup } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { Circle } from 'vant';
import opportunity_winper from "./opportunity_winper/index.vue";
import { format_timestamp_to_DateTime } from "@/utils/date";

const app = createApp();
app.use(Grid);
app.use(GridItem);
app.use(Icon); 
app.use(Cell);
app.use(CellGroup);
app.use(Tab);
app.use(Tabs);
app.use(Col);
app.use(Row);
app.use(Toast);
app.use(Picker);
app.use(Field);
app.use(Popup);
app.use(Collapse);
app.use(CollapseItem);
app.use(Circle);

// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')

// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')

export default {
   name: 'grid',
   setup() {
    const activeName = ref(0);
    const active = ref(0);
    const { forward } = window.history.state
    if (forward && forward.indexOf('/opportunity_winper_add')> -1) {
      active.value = 2;//返回赢单率列表
    }
    console.log(forward)
    const currentRate_month_user = ref(0);
    const currentRate_season_user = ref(0);
    const currentRate_year_user = ref(0);

    var today = new Date();
    const currentDate = ref(today);
    const state = reactive({
      persondata: {},
      personlist: [],
      deptdata: {},
      deptlist: [],
      loading: false,
      finished: false,
      archive:{
        value: '',
        showPicker: false,
        pickdata: [],
        deptid: undefined,
        selectedIndex: '0',
        columns: [],
        firstOpen: true,
      },
      user:{
          rank:{
            value: '',
            showPicker: false,
            pickdata: [],
            deptid: undefined,
            selectedIndex: '0',
            columns: [],
            echartsData: [],
            info: {
              showRankInfo: false,
              orgname: null,
              teamname: null,
              teamrank: null,
              deptrank: null,
              deptname: null
            }
        },
        ranktype:{
          value: '',
          showPicker: false,
          pickdata: [],
          deptid: undefined,
          selectedIndex: '0',
          columns: [],
          showRankType: false
        },
        firstOpen: true,
      },
      showUserTab: true,
      showUserRankTab: false,

      showPicker_year_month: false,
      value_year_month: format_timestamp_to_DateTime(today, 'yyyy-MM'),
      minDate: new Date(2018, 0, 1),
    });
 
    const tabs = reactive({
      '商机赢单率（体验版）': opportunity_winper
    });

    const getUserRankDataById = (parentorgid, deptid, initType) => {
      var userid = window.localStorage.getItem('access_userid');
      var req = JSON.stringify({'deptid': deptid, 'userid': userid, 'parentorgid': parentorgid});
      Toast.loading({
        message: '数据加载中...',
        forbidClick: true,
      });
      getUserRankData(req).then((res) => {
        if (res && res.data) { 
          console.log(res); 
          if(res.data.pl_salearea && res.data.pl_salearea.salesdata){
            var salesdata = res.data.pl_salearea.salesdata;
            console.log(salesdata);
            var obj = JSON.parse(salesdata);
            state.user.rank.pickdata = obj;
            state.user.rank.columns = [];
            obj.forEach((e, index) =>{
              e.index = index;
              console.log(e.index);
              state.user.rank.columns.push(e.text);
              console.log(e.text);

              if((e.isselected + "") === "1"){
                state.user.rank.selectedIndex = index;
                state.user.rank.value = e.text;
                state.user.rank.deptid = e.key;

                state.user.ranktype.showRankType = false;
                if(e.dic && e.dic.length > 0){
                  state.user.ranktype.showRankType = true;

                  state.user.ranktype.pickdata = e.dic;
                  state.user.ranktype.columns = [];
                  e.dic.forEach((e, index) =>{
                    e.index = index;
                    console.log(e.index);
                    state.user.ranktype.columns.push(e.text);
                    console.log(e.text);
 
                    if((e.isselected + "") === "1"){
                      state.user.ranktype.selectedIndex = index;
                      state.user.ranktype.value = e.text;
                      state.user.ranktype.deptid = e.key;
                      console.log(initType);
                    }
                  });
                }
              }
            });
          }
          state.user.rank.echarts = [];
          if(res.data.rank_dept_person && res.data.rank_dept_person.length > 0){
            state.user.rank.echarts = res.data.rank_dept_person;
          }

          state.user.rank.info.showRankInfo = false;
          if(res.data.text_info_person && res.data.text_info_person.orgname){
            state.user.rank.info.showRankInfo = true;
            
            var rankinfo = res.data.text_info_person; 
            state.user.rank.info.orgname = rankinfo.orgname;
            state.user.rank.info.teamrank = rankinfo.teamrank;
            state.user.rank.info.deptrank = rankinfo.deptrank;
            state.user.rank.info.deptname = rankinfo.deptname;
            state.user.rank.info.deptnameShow = rankinfo.deptname?true:false;
          }
        }else{
          //TODO
        }
        console.log('getDeptUserRankDataById');
      }); 
    }

    const getUserDataById = (userid) => {
      var searchdate = state.value_year_month + '-01';
      var body = JSON.stringify({'userid': userid, 'searchdate': searchdate});
      Toast.loading({
          message: '数据加载中...',
          forbidClick: true,
      });
      getPersonData(body).then(res => {
        if (res && res.data) {
          console.log(res); 
          if(res.data.reach_detail){
            state.personlist = [];
            res.data.reach_detail.forEach((e) => {
              e.itemdetail.forEach(d => {
                d.reach_money = comdify(d.reach_money);
              });
              e.month_str = e.month+"月";
              if(e.itemdetail && e.itemdetail.length === 0){
                e.itemdetail.push({reach_money:'无'});
              }
              state.personlist.push(e);
            });
          }
          if(res.data.person_reach){
            state.persondata = res.data.person_reach;
          }  
        }else{
          //TODO
        }
        console.log('getPersonData');
      }); 
    }
    const onLoad = () => {
      //test data
      
      /*
      var token = 'eyJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NzI5MTI1ODcsIkxvZ2luVXNlciI6eyJhY2NvdW50SW5mb0NvZGUiOiIxMzY0ODMwMDkxNjgyNjQ4MDY0IiwiYWNjb3VudENvZGUiOiIxMzY0ODMwMDg5NDEzNTI5NjAwIiwidGVuYW50Q29kZSI6IjEwMDg0NDIiLCJwcm9kdWN0Q29kZSI6IjgzNDY4MzIyMTI0MDE4NDgzNyIsInByb2R1Y3RWZXJzaW9uQ29kZSI6IjgzNDY4NjAxNzQ2OTIwMTg1MSIsImNsaWVudFR5cGVDb2RlIjoxLCJ0b2tlbklkIjoiMTJjODYyOTQtYmUwMS00NGU2LWI0MzctOTA0MWQ1YmI1YjEzIiwib3JnQ29kZSI6IjEiLCJ1c2VySW5mb0lkIjoiMTM2NDgyOTcwOTA0MDQ5MDU1MyIsInVzZXJJbmZvTmFtZSI6IuS4muWKoeaVsOaNrueuoeeQhuWRmCIsInBvc2l0aW9uQ29kZSI6IjEzNjI2OTUxMDMxODA4MzY4NjQiLCJwb3NpdGlvbk5hbWUiOiLkuJrliqHnrqHnkIblkZgiLCJtZW1iZXJDb2RlIjoiMTM2NDgzMDA4OTI2MjUzNDY1NiIsInJlZlBvc2l0aW9uQ29kZSI6IjEzNDM3NzE5MjE2Nzc5NDY4ODAiLCJjYXRlZ29yeUNvZGUiOiIiLCJvcmdTdHJ1Y3RUeXBlSWQiOiIxIiwidXNlck5hbWUiOiIxMDAwMCIsInVzZXJOYW1lMSI6IjE5MDExMTEyMjIyIiwidXNlck5hbWUyIjpudWxsLCJ1c2VyTmFtZTMiOiIxMDAwMCIsInRlbmFudE5hbWUiOiLnjoTorq_kuJrnu6nnrqHnkIbns7vnu58iLCJhcHBDb2RlIjoic2FsZXMiLCJhcHBDb2RlcyI6WyJzYWxlcyJdLCJzdWJQZENvZGVzIjpbInNmYSIsImRtcyIsInBtbSIsInRwbSJdLCJjb2RlcGF0aCI6IjEuIiwiaXNsZWFmb3JnIjoiZmFsc2UiLCJtZXRhbW9kZWx0eXBlIjoyLCJpc1Ntc0xvZ2luIjpmYWxzZX19.5se7JZlUtLYAVcUVl8s94Wvs7i86xgfRzt7V67oNKKw';
      window.localStorage.setItem('access_token', token);
      window.localStorage.setItem('access_userid', '1366266191789821952');
      window.localStorage.setItem('access_username', '黄冰纯'); 
      window.localStorage.setItem('access_deptid', '1365659956388433920'); 
      window.localStorage.setItem('access_deptname', '大消费组织区域');
      window.localStorage.setItem('access_powersign', 3); 
      */
      
      var userid = window.localStorage.getItem('access_userid');
      if(userid){
        getUserDataById(userid);

        var deptid = window.localStorage.getItem('access_deptid');
        var pdeptid = getQueryVariable("pdeptid");
        console.log(pdeptid);
        if(pdeptid){
            deptid = pdeptid;
        } 
        if(deptid){
            getUserRankDataById('', deptid, 0);
        } 
      }
    }

    onLoad();

    var loginResult = false;
    return {
      active,
      state,
      loginResult,
      option: {
        column: [
          {
            label: '团队/人员',
            prop: 'dept_name'
          },
          {
            label: '年度目标(万元)',
            prop: 'year_reach_unit'
          },
          {
            label: '累计达成(元)',
            prop: 'year_reach_total'
          },
          {
            label: '月度达成率',
            prop: 'month_reach_percent'
          },
          {
            label: '季度达成率',
            prop: 'season_reach_percent'
          },
          {
            label: '年度达成率',
            prop: 'year_reach_percent'
          }
        ]
      },
      getUserDataById,
      getUserRankDataById,
      activeName,
      currentRate_month_user,
      currentRate_season_user,
      currentRate_year_user,
      tabs,

      currentDate
    };
  },
  components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Icon.name]: Icon,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Col.name]: Col,
      [Row.name]: Row,
      [Toast.name]: Toast,
      [Picker.name]: Picker,
      [Field.name]: Field,
      [Popup.name]: Popup,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
      [Circle .name]: Circle,
  },
  data() {
    return {
      loginStatus: this.getLoginStatus(),
    };
  },
  methods: {
    getLoginStatus(){
      var activeTemp = this.$route.query.active;
      console.log(activeTemp);
      if(activeTemp){
        this.active = ref(parseInt(activeTemp));
      }
      console.log('getLoginStatus');
      var token = window.localStorage.getItem('access_token');
      var username = window.localStorage.getItem('access_username');
      var msg =  "[登录失败]请联系管理员";
      if(token){
        msg = username + "[登录成功]";
        this.loginResult = true;
      }
      return msg;
    },
    onConfirm_yearMonth(value) {
      console.log('onConfirm_yearMonth');
      this.state.value_year_month = format_timestamp_to_DateTime(value, 'yyyy-MM');
      this.state.showPicker_year_month = false;
      
      var userid = window.localStorage.getItem('access_userid');
      if(userid){
        this.getUserDataById(userid);
      }
    },
    openDetail(item) {
      console.log('openDetail');
      console.log(item);
      if(item){
        if(item.sign && item.dept_id){
          if(item.sign === '1'){
            this.$router.push({
              path: '/team', query:{deptid: item.dept_id, deptname: encodeURIComponent(item.dept_name), pdeptid: this.state.deptid}
            });
          }else if(item.sign === '2'){
            this.$router.push({
              path: '/person', query:{
                  userid: item.dept_id, 
                  username: encodeURIComponent(item.dept_name),
                  source: 'home',
                  pdeptid: this.state.deptid
                }
            });
          }
        }
      }
    },
    onConfirmRank(value) {
      console.log('onConfirmRank');
      this.state.user.rank.value = value;
      this.state.user.rank.showPicker = false;
 
      this.state.user.rank.pickdata.forEach((e) =>{
        if(e.text === this.state.user.rank.value){
          this.state.user.rank.deptid = e.key;
          this.getUserRankDataById(e.key, e.key, 1);
          this.refreshEcharUser();
        }
      });
    },
    clickTab(number){
      console.log(number);
      if(number === 0){
        if(this.state.archive.firstOpen){
          Toast.loading({
            message: '数据加载中...',
            forbidClick: true,
         });
        }
        this.state.archive.firstOpen = false;

        this.state.showUserRankTab = false;
        this.state.showUserTab = true;
      }else if(number === 1){
        if(this.state.archive.firstOpen){
          Toast.loading({
            message: '数据加载中...',
            forbidClick: true,
          });
        }
        this.state.archive.firstOpen = false;

        this.state.showUserRankTab = true;
        this.state.showUserTab = false;
        
        this.refreshEcharUser();
      }
    },
    refreshEcharUser(){
      setTimeout(() => {
        this.drawLineUser();
      }, 1500);
    },
    drawLineUser(){
      let showData = [];
      showData.push(['score', 'product']);
      this.state.user.rank.echarts.forEach((item) => {
        showData.push([item.year_reach, item.orgname]);
      });
      this.drawLine('echartUser', showData);
    },
    drawLine (div, showData) {
      // 基于准备好的dom，初始化echarts实例
      let eChart = echarts.init(document.getElementById(div))
      // 绘制图表
      var option = {
        dataset: {
          source: showData
        },
        grid: { containLabel: true,
        x: 10,
        y: 10,
        x2: 80,
        y2: 60, },
        xAxis: { name: '比例', position:'middle' },
        yAxis: { name: '团队', type: 'category' },
        series: [
          {
            type: 'bar',
            barWidth: 20,
            encode: {
              // Map the "score" column to X axis.
              x: 'score',
              // Map the "product" column to Y axis
              y: 'product'
            },
            itemStyle: {
							normal: {
								label: {
									show: true,  //开启显示
									position: 'right',  //在上方显示
									textStyle: {  //数值样式
										color: 'black',
										fontSize: 16
									}
								}
							}
						}
          }
        ]
      };
      eChart.setOption(option)
    }
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

/deep/ .van-cell__value{
  color: orange;
}

.projectname {
  color: red;
}

.vant-table {
  .table {
    border-radius: .185185rem;
    text-align: center;
    font-size: 12px;
    border-collapse:collapse ; 
    .th {
      height: 2;
      line-height: 2;
      background-color:white;
      color: gray;
      border-top-left-radius: .185185rem;
      border-top-right-radius: .185185rem;
    }
    .list-tr {
      height: 2;
      line-height: 2;
      border-spacing:0px 10px;
    }
    .list-tr:nth-child(2n) {
      background-color: white;
    }
  }

  table,table tr th, table tr td { border:1px solid rgb(216, 212, 212); }
}

.div{
  font-size:12px;
  text-align:left;
  font-weight:bold
}
</style>
